document.addEventListener("DOMContentLoaded", function () {
  const siteHeader = document.querySelector(".site-header");
  const headerHeartIcon = document.querySelector(".wlh-icon-heart-empty");

  // Add scroll event listener to the window
  window.addEventListener("scroll", function () {
    // Get the current scroll position
    const scrollPosition = window.scrollY;
    if (scrollPosition >= 150) {
      siteHeader.style.backgroundColor = "white";
    } else {
      siteHeader.style.backgroundColor = "rgba(20, 34, 42, 0.4)";
    }
  });
  // Select the rating item
  var ratingItem = document.querySelector(
    '.trustshop-collection-rating--item[rating-count="0"]'
  );

  if (ratingItem) {
    // Select all SVG elements inside the rating item
    var svgs = ratingItem.querySelectorAll("svg.trustshop-form-avg-star--item");
    // Change the fill color to gray
    svgs.forEach(function (svg) {
      var stops = svg.querySelectorAll("stop");
      stops.forEach(function (stop) {
        stop.setAttribute("stop-color", "#e2e2e2");
      });
    });
  }
});
